import rest from "@/rest-client";

export const processingLegalRecommendation = {
  state: {
    recommendations: null,
    showRecommendations: false,
  },
  getters: {
    recommendations: (state) => state.recommendations,
    showRecommendations: (state) => state.showRecommendations,
  },
  mutations: {
    recommendations: (state, value) => {
      state.recommendations = value;
    },
    showRecommendations: (state, value) => {
      state.showRecommendations = value;
    },
  },
  actions: {
    async paginateRecommendation({ commit, rootGetters }, { pagination }) {
      commit("isLoading", true);
      try {
        const criteria = rootGetters["inventoryFilter/criteria"];
        const process = criteria.process;
        const datasource = criteria.datasource;
        const datasubject = criteria.datasubject;
        commit("recommendations", undefined);
        if (process) {
          const response = await rest.post(`/recommendation/paginate/process-datasource-datasubject-processing-legal`, {
            pagination,
            datasourceId: datasource?._id,
            processId: process?._id,
            datasubjectId: datasubject?._id,
          });
          commit("recommendations", response.data);

          return response;
        }
      } finally {
        commit("isLoading", false);
      }
    },
  },
};

export const transferingLegalRecommendation = {
  state: {
    recommendations: null,
    showRecommendations: false,
  },
  getters: {
    showRecommendations: (state) => state.showRecommendations,
    recommendations: (state) => state.recommendations,
  },
  mutations: {
    recommendations: (state, value) => {
      state.recommendations = value;
    },
    showRecommendations: (state, value) => {
      state.showRecommendations = value;
    },
  },
  actions: {
    async paginateRecommendation({ commit, rootGetters }, { pagination }) {
      commit("isLoading", true);
      try {
        const criteria = rootGetters["inventoryFilter/criteria"];
        const receiverGroup = criteria.receiverGroup;
        const process = criteria.process;
        const datasource = criteria.datasource;
        const datasubject = criteria.datasubject;
        commit("recommendations", undefined);
        if (receiverGroup && process) {
          const response = await rest.post(`/recommendation/paginate/process-datasource-datasubject-transfering-legal`, {
            pagination,
            datasourceId: datasource?._id,
            receiverGroupId: receiverGroup?._id,
            processId: process?._id,
            datasubjectId: datasubject?._id,
          });
          commit("recommendations", response.data);

          return response;
        } else {
          commit("recommendations", undefined);
        }
      } finally {
        commit("isLoading", false);
      }
    },
  },
};
